import ProductList from 'components/Product/ProductList';
import Breadcrumbs from 'components/ui/Breadcrumbs';
import Flex from 'components/ui/Flex';
import Text from 'components/ui/Text';
import useAppDispatch from 'hooks/useAppDispatch';
import useAppSelector from 'hooks/useAppSelector';
import { useEffect } from 'react';
import { getFilters, loadProducts } from 'store/reducers/assortmentSlice';
import styled from 'styled-components/macro';

const Products = () => {
    const { products, assortmentPageInfo, loading, categories, currentPathName, searchPhrase } = useAppSelector(
        ({ assortment }) => assortment,
    );

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(loadProducts({ page: 1 }));
        dispatch(getFilters());
    }, [dispatch, categories, currentPathName, searchPhrase]);

    return (
        <Flex column>
            <Breadcrumbs className="pb-2" activePage={currentPathName} />
            <h2 className="px-3 f2-700">{categories[currentPathName]?.name ?? ''}</h2>
            {categories[currentPathName]?.description && (
                <Text className="px-3">{categories[currentPathName]?.description}</Text>
            )}
            <ProductList
                products={products}
                assortmentPageInfo={assortmentPageInfo}
                loading={loading}
                enableFilters={true}
            />
        </Flex>
    );
};

export default Products;
